export default function (vuiEmojis) {
  'ngInject';

  const rEmojis = new RegExp("(" + vuiEmojis.EMOJI.join("|") + ")", "g");

  return input => {
    if (!input || !input.replace) {
      return '';
    }
    return input.replace(rEmojis, (match, text) => {
      return `<img src="${require(`/assets/img/chat/opacity.png`)}" class="smile smile-` + vuiEmojis.EMOJI_HEX[text] + `" title="` + vuiEmojis.EMOJI_HEX[text] + `">`;
    });
  };
}
